import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["form", "fileInput"]

  click(event) {
    event.preventDefault();

    this.fileInputTarget.click();
  }

  sendForm() {
    this.formTarget.submit();
  }
}
